module.exports = __webpack_public_path__ + "img/none-deck.92e4126.png";